import { render, staticRenderFns } from "./proofCreate.vue?vue&type=template&id=5aad55bd&"
import script from "./proofCreate.vue?vue&type=script&lang=js&"
export * from "./proofCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports